module.exports = "<div class=\"vis-chart\">\n  <slot name=\"header\"></slot>\n  <div ref=\"chartElement\" class=\"vis-chart-container\"></div>\n  <slot name=\"footer\"></slot>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./~/wc-visualisation/src/components/chart.html
// module id = 308
// module chunks = 0